import { Button, Col, ConfigProvider, message, Popconfirm, Row, Table } from 'antd';
import React, { forwardRef, useImperativeHandle, useRef, useState, useEffect } from 'react';
import {SActionBtn, SCommonTable, SFuncModal, SLowcodeList, STableActions} from 'shj-components';
import { get, isArray, isFunction } from 'lodash-es';
import {
  clearDashboardUsers, fetchMenber,
  findBaseBizOpInfoById,
  findDashboardUsers,
  findMoaFlag,
  updateDashboardUser
} from "@/services/kuAccount.ts";
// import { fetchMenber, clearDashboardUsers, findDashboardUsers, updateDashboardUser, findBaseBizOpInfoById } from '@/services/custom';

// 修改添加成员
export const menberDialog = (props: { moaFlag: any, bizId: any, caseId: any, casesDashboardId?: any, tableRef: any }) => {
  const destroy = () => {
    dialog.destroy()
  }
  const dialog = SFuncModal({
    title: '添加/修改成员',
    cancelText: '取消',
    vanish: true,
    content: <MenberModal onClose={destroy} {...props} />,
  });
}
const MenberModal = (props: any) => {
  const { onClose, moaFlag, bizId, caseId, casesDashboardId, tableRef } = props;
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [menber, setMenber] = useState([]);
  const currentMenber = useRef<any>();
  useEffect(() => {
    initFn();
  }, [])
  const initFn = () => {
    setLoading(true)
    fetchMenber({ params: { bizId, moaFlag } }).then((resp: any) => {
      setMenber(resp || [])
    }).finally(() => {
      setLoading(false)
    });
  }
  const onFinish = () => {
    if(loading) return;
    if(!currentMenber.current) return message.error('请选择数据')
    setBtnLoading(true)
    updateDashboardUser({
      params: { casesId: caseId },
      data: {
        // casesDashboardId: record?.casesDashboardId, //控制台ID  如果值为null创建新的工作台并添加该用户
        casesDashboardId: casesDashboardId, //控制台ID  如果值为null创建新的工作台并添加该用户
        workNumber: currentMenber.current?.workNumber, //人员工号
        deptCode: currentMenber.current?.deptId, //人员部门code
        posCode: currentMenber.current?.roleCode, //人员职位code
        companyCode: currentMenber.current?.companyId, //人员所属公司code
        userResType: moaFlag == 'pri' ? 'principal' : 'member', //职责类型 (非必传)
      }
    }).then((resp: any) => {
      tableRef.current.reload();
      message.success('操作成功');
      onClose();
    }).finally(() => { setBtnLoading(false) });
  };
  return (
    <SFuncModal.Content
      okText='确认'
      onCancel={onClose}
      confirmLoading={btnLoading}
      onOk={onFinish} >
      <ConfigProvider>
        <Table
            pagination={false}
          loading={loading}
          scroll={{y: 350}}
          rowSelection={{
            type: 'radio',
            onChange: (selectedRowKeys: React.Key[], selectedRows: any) => {
              // console.log(selectedRowKeys, selectedRows);
              currentMenber.current = selectedRows[0];
            },
          }}
          dataSource={menber}
          rowKey={(record: any) => {
            return record.ucenterUserId;
          }}
          columns={[
            { title: '姓名', dataIndex: 'name' },
            { title: '工号', dataIndex: 'workNumber' },
          ]}
        />
        {/* <Row>
          <Col span={24} style={{ textAlign: 'right' }}>
            <Button type="primary" onClick={onFinish}>
              确定
            </Button>
          </Col>
        </Row> */}
      </ConfigProvider>

    </SFuncModal.Content>
  )
}

// 成员列表
export const ModalArtDesignFnlDom: React.FC<any> = forwardRef((props, ref) => {
  const { onUpdate, bizId, moaFlag } = props;
  const tableRef = useRef<any>();
  const [params] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const [caseId, setCaseId] = useState('');
  // const [moaFlag, setMoaFlag] = useState();
  const columns: any[] = [
    {
      title: '姓名',
      dataIndex: 'workName',
      width: 'auto',
    },
    {
      title: '职位',
      dataIndex: 'userResTypeName',
      width: 'auto',
    },
    {
      title: '操作',
      dataIndex: '#',
      width: '130',
      render: (text: any, record: any) => {
        return operCellRender(record);
      },
    },
  ];

  const reload = () => {
    tableRef.current.reload();
  };

  useImperativeHandle(
    ref,
    () => ({
      reload,
    }),
    [],
  );

  const fetchList = async () => {
    setLoading(true);
    return new Promise(async (resolve, reject) => {
      try {
        findBaseBizOpInfoById({ data: { id: bizId } }).then((resp: any) => {
          const newList = isArray(resp) ? resp : []
          if (newList[0]?.caseId) {
            // console.log('成员列表-获取caseId::', newList[0]?.caseId);
            setCaseId(newList[0].caseId);
            findDashboardUsers({ params: { casesId: newList[0]?.caseId } }).then((newList: any) => {
              const _users = newList.map((val: any) => {
                return {
                  workName: get(val, 'currentUser.workName', ''),
                  userResTypeName: get(val, 'userResTypeName', ''),
                  casesDashboardId: get(val, 'casesDashboardId', ''),
                };
              });
              resolve({ records: [..._users], total: newList.length});
            }).catch(() => {
              reject({ success: false });
            });
          } else {
            resolve({records: [], total: 0});
          }
        });
      } catch (e) {
        reject({ success: false });
        setLoading(false);
      }
    });
  };

  // 删除
  const deleteMenberFn = (record: any) => {
    clearDashboardUsers({
      data: {
        casesId: caseId, //案例ID
        casesDashboardIdList: [record.casesDashboardId], //控制台ID
      }
    }).then((res: any) => {
      tableRef.current.reload();
      message.success('操作成功');
    });
  };

  const operCellRender = (record: any) => {
    return <STableActions>
      <SActionBtn
        disabled={!(moaFlag == 'pri')}
        onClick={() => {
          if (record.userResTypeName == '负责人') {
            isFunction(onUpdate) && onUpdate(caseId);
            menberDialog({ moaFlag: 'pri', bizId, caseId, casesDashboardId: record?.casesDashboardId, tableRef });
          } else {
            menberDialog({ moaFlag: 'menber', bizId, caseId, casesDashboardId: record?.casesDashboardId, tableRef });
          }
        }}
        style={{ marginRight: '20px' }}
      >
        编辑
      </SActionBtn>
      {record.userResTypeName != '负责人' && (
        <SActionBtn
          disabled={!(moaFlag == 'pri')}
          confirm
          title="确定要删除吗"
          onClick={() => deleteMenberFn(record)}
          danger
        >
          删除
        </SActionBtn>
      )}
    </STableActions>
  };
  const toolbarRender = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <span>美学大师成员</span>
        <Button
          onClick={() => {
            menberDialog({ moaFlag: 'menber', bizId, caseId, tableRef });
          }}
          disabled={!(caseId && moaFlag == 'pri')}
          type="primary"
        >
          新增成员
        </Button>
      </div>
    );
  };

  const extensions = {
    request: {fetchList}
  }

  return (
    <div>
      <SLowcodeList ref={tableRef} config={{columns, toolbar: toolbarRender(), rowSelection: false}} {...extensions}/>
    </div>
  );
});

